CDN.requireOnce([
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.Control_ProgressBar, },
], () => {
    $(document).ready(() => {
        let lightdiv = $("<div class='light' style='width: 400px;height: 40px;padding: 10px;'>");
        $("body").append(lightdiv);

        let progressBar = new CDN.Controls.ProgressBar(lightdiv.get(0), {
            values: {
                val: 0,
                min: 0,
                max: 100,
            },
            text: {
                left: (value, data) => `${value.val}%`,
            }
        });

        let start = Date.now();

        let updateValue = () => {
            let timePassed = (Date.now() - start) / 2000;
            progressBar.setValues({
                val: 50 + Math.round(Math.sin(timePassed) * 50),
                min: 0,
                max: 100
            });
            setTimeout(updateValue, 50);
        };

        updateValue();
    });
});